import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Glossary from "@/pages/Glossary";
import TermDetail from "@/pages/TermDetail";
import Recipes from "@/pages/Recipes";
import RecipeDetail from "@/pages/RecipeDetail";
import Admin from "@/pages/Admin";
import FAQ from "@/pages/FAQ";
import PaymentSuccess from "@/pages/PaymentSuccess";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/glossary" element={<Glossary />} />
          <Route path="/term/:slug" element={<TermDetail />} />
          <Route path="/recipes" element={<Recipes />} />
          <Route path="/recipe/:slug" element={<RecipeDetail />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
        </Routes>
      </Layout>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
